module.exports = __webpack_public_path__ + "static/media/g2academy_logo.cf713b6d.png";